import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { EstadoBadge, OrigenBadge } from "@/components/common";
import { Briefcase } from "lucide-react";

export function HistorialLaboral({ vid }) {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/vinculaciones/${vid}/persona`).then((r) => setD(r.data)).catch(() => setD(null)); }, [vid]);
  if (!d || d.vinculaciones.length < 2) return null;
  const contratos = (x) => d.contratos.filter((c) => c.vinculacion_id === x).map((c) => c.numero_contrato).join(", ");
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-testid="historial-laboral">
      <p className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-800"><Briefcase className="h-4 w-4 text-vino-700" /> Historial laboral de esta persona · {d.vinculaciones.length} vinculaciones</p>
      <div className="divide-y divide-slate-100">
        {d.vinculaciones.map((x) => (
          <button key={x.id} onClick={() => navigate(`/empleados/${x.id}`)} data-testid={`historial-vinc-${x.id}`}
            className={`flex w-full flex-wrap items-center justify-between gap-2 px-2 py-2 text-left text-sm transition-colors hover:bg-vino-50/50 ${x.id === vid ? "bg-vino-50/60" : ""}`}>
            <span className="min-w-0"><span className="font-medium text-slate-800">{x.empresa_cliente || "—"}</span> <span className="text-slate-500">· {x.cargo || "sin cargo"} · ingreso {x.fecha_ingreso || "—"}{contratos(x.id) && ` · contrato ${contratos(x.id)}`}</span>{x.id === vid && <span className="ml-2 text-[11px] font-semibold text-vino-700">(viendo)</span>}</span>
            <span className="flex gap-1.5"><OrigenBadge origen={x.origen} /><EstadoBadge estado={x.estado} /></span>
          </button>
        ))}
      </div>
    </div>
  );
}
